import React from 'react';
import CanConnect from './can-connect/connected';
import NoPermission from './no-permission';
import { type Props } from './types';

export const ConnectSpace = ({ isProjectMember }: Props) => {
	switch (isProjectMember) {
		case true:
			return <CanConnect />;
		case false:
			return <NoPermission />;
		default:
			return null; // isProjectMember = undefined (still fetching), don't render anything yet
	}
};
